(() => {
  const controls = document.querySelector('[data-flow-filter-controls]');

  if (!controls) return;

  const emptyMessage = document.querySelector('[data-flow-empty]');

  const applyFilter = (filter) => {
    const products = [...document.querySelectorAll('[data-flow-product]')];
    let visibleCount = 0;

    products.forEach((product) => {
      const keywords = product.dataset.flowKeywords || '';
      const isVisible =
        filter === 'all' ||
        (filter === 'available' && product.dataset.flowAvailable === 'true') ||
        keywords.includes(filter);

      product.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    controls.querySelectorAll('[data-flow-filter]').forEach((button) => {
      const isActive = button.dataset.flowFilter === filter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
  };

  controls.addEventListener('click', (event) => {
    const button = event.target.closest('[data-flow-filter]');
    if (!button) return;

    applyFilter(button.dataset.flowFilter);
  });
})();
